import { ViewApplicationTaskListData } from "../data/ViewApplicationTaskList.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }
    const dropdownLists = {
        "channel": filterDropDownList("SGBC Channel"),
        "categoryL1": filterDropDownList("Products Category L1"),
        "categoryL2": filterDropDownList("Products Sub Category L2"),
        "categoryL3": filterDropDownList("Products Type L3"),
        "statusId": filterDropDownList("Product Service Status"),
    };

    const formFields = [...ViewApplicationTaskListData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};